import { Box, Typography } from "@mui/material";
import axios from "axios";
import { ContainedButton1 } from "components/DesignSystem/Button";

const RaiseTicketButton = () => {
    const handleLogin = (username) => {
        console.log("process.env.REACT_APP_TICKETING_PASS; ", process.env.REACT_APP_TICKETING_PASS)
        console.log("typeof process.env.REACT_APP_TICKETING_PASS; ", typeof (process.env.REACT_APP_TICKETING_PASS))
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://tickets.staging.getwilldone.com/login";
        form.target = '_blank'
        form.style.display = "none";
        // Add username and password fields
        const usernameField = document.createElement("input");
        usernameField.type = "hidden";
        usernameField.name = "login-username";
        usernameField.value = username; // Replace with actual username

        const passwordField = document.createElement("input");
        passwordField.type = "hidden";
        passwordField.name = "login-password";
        // passwordField.value = password; // Replace with actual password
        passwordField.value = process.env.REACT_APP_TICKETING_PASS;
        form.appendChild(usernameField);
        form.appendChild(passwordField);

        document.body.appendChild(form);
        form.submit();
    };

    const handleClick = async () => {
        try {
            const res = await axios.get("/testator/get-credentials");
            const { username, password } = res.data.credentials;
            handleLogin(username, password);
        } catch (error) {
            console.log("error", error);
        }
    };

    return (
        <Box>
            <ContainedButton1 sx={{ height: '45px', padding: '0 8px', textTransform: 'none' }} onClick={handleClick}>
                <Typography variant="bodyText4" >Raise a Ticket</Typography>
            </ContainedButton1>
        </Box>
    )
};

export default RaiseTicketButton;